<template>
  <el-container>
    <el-main>
      <el-form label-width="100px">
        <el-tabs>
          <el-tab-pane label="基础配置">
            <el-form-item label="平台启动">
              <el-switch v-model="settings.open"></el-switch>
            </el-form-item>
            <el-form-item label="平台地址">
              <el-input v-model="settings.domain"></el-input>
            </el-form-item>
            <el-form-item label="合作热线">
              <el-input v-model="settings.tel"></el-input>
            </el-form-item>
            <el-form-item label="合作邮箱">
              <el-input v-model="settings.email"></el-input>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="备案配置">
            <el-form-item label="备案号">
              <el-input v-model="settings.icp"></el-input>
            </el-form-item>
            <el-form-item label="ICP备案链接">
              <el-input v-model="settings.icp_url"></el-input>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="短信接口">
            <el-form-item label="短信类型">
              <el-select>
                <el-option label="阿里云" value="腾讯云"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="AccessKeyId">
              <el-input></el-input>
            </el-form-item>
            <el-form-item label="AccessKeySecret">
              <el-input></el-input>
            </el-form-item>
            <el-form-item label="短信签名">
              <el-input></el-input>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="微信支付接口">
            <el-form-item label="证书序列号">
              <el-input></el-input>
            </el-form-item>
            <el-form-item label="支付Key">
              <el-input></el-input>
            </el-form-item>
            <el-form-item label="支付公钥">
              <el-input></el-input>
            </el-form-item>
            <el-form-item label="支付公钥证书">
              <el-upload><el-button>上传</el-button></el-upload>
            </el-form-item>
            <el-form-item label="微信商户商户号">
              <el-input></el-input>
            </el-form-item>
            <el-form-item label="微信支付证书">
              <el-upload><el-button>上传</el-button></el-upload>
            </el-form-item>
            <el-form-item label="微信支付证书密钥">
              <el-upload><el-button>上传</el-button></el-upload>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="电子发票接口"></el-tab-pane>
        </el-tabs>
        <el-form-item>
          <el-button type="primary">提交</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Dashboard',
  data () {
    return {
      settings: {
        open: true,
        domain: 'https://',
        tel: '',
        email: '',
        icp: '粤IPC备XXX号',
        icp_url: 'https://beian.miit.gov.cn/',
        waf_type: 1,
        waf_content: ''
      }
    }
  },
  mounted () {
    console.log(this.records)
  },
  methods: {
    save () {

    }
  }
}
</script>

<style scoped>
.el-aside {
  border-right: 1px solid #ddd;
}
.list-group li {
  cursor: pointer;
  padding: 0 10px;
}
.list-group li:hover, .list-group li.active {
  background-color: #ecf5ff;
}
</style>
